var render = function render(){var _vm=this,_c=_vm._self._c;return _c('address-form',{attrs:{"title":"ویرایش آدرس","submit-function":_vm.updateAddress}})
}
var staticRenderFns = []

export { render, staticRenderFns }